
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class BacAlert extends Vue {
    @Prop({ default: 'alert' }) type!: string

    get classes () {
      switch (this.type) {
        case 'alert':
          return 'uk-alert-danger uk-alert'
        case 'check':
          return 'uk-alert-success uk-alert'
        case 'error':
          return 'uk-alert-danger uk-alert'
        case 'info':
          return 'uk-alert-info uk-alert'
      }
    }

    get icon () {
      switch (this.type) {
        case 'alert':
          return 'warning'
        case 'check':
          return 'check'
        case 'error':
          return 'close'
        case 'info':
          return 'warning'
      }
    }
}
